export default {
  init() {
    let scrollPosition = window.scrollY;
    const navbar = document.querySelector('header .navbar')
    //const root = document.querySelector(':root')
    const scrollNavbar = () =>
    {
      /*
      const max = window.innerHeight * 0.9
      const min = 0 //window.innerHeight * 0.45
      let op = (window.scrollY - min) / (max - min)
      op = op < 0 ? 0 : op
      op = op > 1 ? 1 : op
      op = op * 0.7
      root.style.setProperty('--navbar-opacity', op)
      */
      const scrollLimit = window.innerHeight * 0.25
      if(window.scrollY > scrollLimit && window.scrollY != scrollPosition){
        if(window.scrollY > scrollPosition){
          navbar.classList.add('navbar-up')
        }
        else {
          navbar.classList.remove('navbar-up')
        }
      }
      scrollPosition = window.scrollY
      window.requestAnimationFrame(scrollNavbar)
    }
    window.requestAnimationFrame(scrollNavbar)
    //window.addEventListener('scroll', scrollNavbar)
    //scrollNavbar()

    // Dealing with Textarea Height
    function calcHeight(value)
    {
      const lineHeightPercentage = 1.2467
      const fontSize = 20
      const lineHeight = fontSize * lineHeightPercentage
      let numberOfLineBreaks = (value.match(/\n/g) || []).length
      numberOfLineBreaks = numberOfLineBreaks < 2 ? 2 : numberOfLineBreaks
      // min-height + lines x line-height + padding + border
      let newHeight = (numberOfLineBreaks + 1) * lineHeight + 24 + 2
      return newHeight
    }

    let textareas = Array.from(document.getElementsByTagName('textarea'))
    textareas.forEach(textarea =>
    {
      textarea.addEventListener('keyup', () =>
      {
        textarea.style.height = calcHeight(textarea.value) + 'px'
      })
    })
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js